import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AuthProvider } from '../../providers/auth';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../providers/user';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'app-splash',
    templateUrl: './splash.component.html',
    styleUrls: ['./splash.component.css']
})
export class SplashComponent implements OnInit {

    private _success = new Subject<string>();
    successMessage: string;

    constructor(public _auth: AuthProvider, private afAuth: AngularFireAuth, public router: Router, private navParams: ActivatedRoute, private _user: User) { }

    ngOnInit() {
        this._auth.loginEmitter.subscribe(url => {
            if (this._auth.userLoggend.baneado) {
                this._success.next(`No tienes permiso para acceder a la aplicación. Contacta con el administrador`);
                setTimeout(() => {
                    this._auth.logout();
                }, 4000);
            } else {
                if (url)
                    this.router.navigate([url]);
                else
                    this.router.navigate(['dashboard']);
            }
        });

        this._auth.logoutEmitter.subscribe(result => {
            if (result.finishSignUp) {
                console.log('finishSignUp', this.navParams.snapshot.paramMap.get('uid'));
                this._user.findPreviousRegistration(this.navParams.snapshot.paramMap.get('uid')).then(user => {
                    if (user) {
                        console.log('findPreviousRegistration', user);
                        this._auth.userPrev = user;
                        if(this.afAuth.auth.isSignInWithEmailLink(window.location.href)){
                            this.router.navigate(['registro/' + this.navParams.snapshot.paramMap.get('uid')]);
                        }else{
                            this._success.next('url no permitida o caducada, pida otra url al administrador');
                        }
                    }else{
                        this._success.next(`No tiene permiso de activacion. Solicite el link de activacion al administrador.`);
                    }
                    /* this._auth.checkLinkEmail(window.location.href, user.email).then((r: any) => {
                        console.log(r)
                        // this._user.removePreviousRegistration(this.navParams.snapshot.paramMap.get('uid')).then(_ => {
                        //     user.id = r.uid;
                        //     console.log('new user', user);
                        //     this._user.store(user);
                        // });
                    }).catch(e => console.log(e)); */
                })
            } else {
                if(result.baned){
                    this._success.next(`No tiene permiso para usar la aplicación. Consulte al administrador.`);
                }else{
                    this.router.navigate(['login']);
                }
            }
        });

        this._success.subscribe((message) => this.successMessage = message);
        this._success.pipe(
            debounceTime(5000)
        ).subscribe(() => {this.successMessage = null; this.router.navigate(['']);});
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/splash/splash.component.ts